import '@popperjs/core';
import 'bootstrap';

import '@/front/patch/urlAdaptor';

import '@/front/cldr';

import '@/front/account';
import '@/front/accountPicker';
import '@/front/action';
import '@/front/bookkeepingFrequencyPicker';
import '@/front/charityRegisterLink';
import '@/front/checklistTemplatePicker';
import '@/front/clientLimitRelationship';
import '@/front/companiesHouseSearch';
import '@/front/copyLink';
import '@/front/customFields';
import '@/front/dashboard';
import { setDeviceId } from '@/front/device';
import '@/front/documents';
import '@/front/editable';
import '@/front/formEditor';
import '@/front/formatters';
import '@/front/grid';
import '@/front/gridAmlInterceptor';
import '@/front/individualRelationshipTypePicker';
import '@/front/individualTaxReturnRequiredPicker';
import '@/front/lookupPicker';
import '@/front/modal';
import '@/front/mtdItQuarterPicker';
import '@/front/mtdItTaxReturnTitle';
import '@/front/offcanvas';
import { hideOffcanvas, showOffcanvas } from '@/front/offcanvas';
import '@/front/onboardingVideoModal';
import '@/front/organisationTypePicker';
import '@/front/payrollFrequencyPicker';
import '@/front/placeholderPopup';
import '@/front/request';
import '@/front/resize';
import '@/front/scheduleFrequencyPicker';
import '@/front/schedulePreview';
import '@/front/search';
import '@/front/sectionNav';
import '@/front/smartTaskTypePicker';
import '@/front/subTask';
import '@/front/taskClientTypePicker';
import '@/front/templatePicker';
import '@/front/tooltip';
import '@/front/widthToggle';

document.addEventListener('DOMContentLoaded', () => {
  setDeviceId();

  const open = new URLSearchParams(window.location.search).get('open');

  if (open?.startsWith('/')) {
    showOffcanvas({ url: open });
    return;
  }

  const { hash } = window.location;

  if (hash) {
    const link = document.getElementById(hash.substring(1)) as HTMLAnchorElement | null;

    if (link?.href) {
      link.click();
    }
  }
});

const w = window as any;

w.prefillBeacon = (data: { subject: string; text: string }) => {
  w.Beacon('prefill', data);
  w.Beacon('open');
  w.Beacon('navigate', '/ask/message/');
};

w.hideOffcanvas = hideOffcanvas;
